import { render } from "./TNotification.vue?vue&type=template&id=746f7ffc&scoped=true"
import script from "./TNotification.vue?vue&type=script&lang=js"
export * from "./TNotification.vue?vue&type=script&lang=js"

import "./TNotification.vue?vue&type=style&index=0&id=746f7ffc&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746f7ffc"]])

export default __exports__